import type { ControlDataVersion, VehicleSoftwareVersion } from '@/api/main/types.gen'

export const VEHICLE_CONTROL_DATA_SCHEMA = 'control_data_vehicle'
export const NEXT_CONTROL_DATA_SCHEMA = 'control_data_next'

export const CONTROL_DATA_SCHEMAS = [VEHICLE_CONTROL_DATA_SCHEMA, NEXT_CONTROL_DATA_SCHEMA] as const

export type ControlDataSchemaName = (typeof CONTROL_DATA_SCHEMAS)[number]

export type DataVersionMatch = 'vehicle' | 'next' | 'mismatch' | 'missing'

export const DATA_VERSION_MATCH_COLOR: Record<DataVersionMatch, string> = {
  vehicle: 'green.1',
  next: 'yellow.2',
  mismatch: 'red.2',
  missing: 'red.2',
}

export const INVALID_SOFTWARE_VERSION_COLOR = 'red.2'

export const HIGHLIGHTED_TEXT_COLOR = 'dark.9'

const sameInstant = (left: string, right: string) => {
  const parsedLeft = Date.parse(left)
  const parsedRight = Date.parse(right)

  return Number.isNaN(parsedLeft) || Number.isNaN(parsedRight) ? left === right : parsedLeft === parsedRight
}

export const sameDataVersion = (left?: ControlDataVersion, right?: ControlDataVersion) =>
  !!left &&
  !!right &&
  left.type === right.type &&
  left.map_version === right.map_version &&
  sameInstant(left.modified_at, right.modified_at)

export const matchDataVersion = (
  vehicleVersion: ControlDataVersion | undefined,
  backendVersions: Partial<Record<ControlDataSchemaName, ControlDataVersion>>
): DataVersionMatch => {
  if (!vehicleVersion) return 'missing'
  if (sameDataVersion(vehicleVersion, backendVersions[VEHICLE_CONTROL_DATA_SCHEMA])) return 'vehicle'
  if (sameDataVersion(vehicleVersion, backendVersions[NEXT_CONTROL_DATA_SCHEMA])) return 'next'
  return 'mismatch'
}

const UNKNOWN_SOFTWARE_VERSION_FIELD = 'UNKNOWN'

export const softwareVersionField = (value?: string) =>
  !value || value === UNKNOWN_SOFTWARE_VERSION_FIELD ? undefined : value

export const isSoftwareVersionValid = (softwareVersion?: VehicleSoftwareVersion) =>
  !!softwareVersionField(softwareVersion?.tag)
